import styled from 'styled-components';
import { Divider as MuiDivider } from '@material-ui/core';
import { spacing } from '@material-ui/system';

export const Divider = styled(MuiDivider)(spacing);
